import type { ResponseVoice } from '@ssml-editor/editor-vue';

export default <ResponseVoice[]>[
  {
    value: 'longjiqi',
    name: '龙机器',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E6%9C%BA%E5%99%A8.mp3',
  },
  {
    value: 'longhouge',
    name: '龙猴哥',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E7%8C%B4%E5%93%A5.mp3',
  },
  {
    value: 'longjixin',
    name: '龙机心',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E6%9C%BA%E5%BF%83.mp3',
  },
  {
    value: 'longanyue',
    name: '龙安粤',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E5%AE%89%E7%B2%A4.mp3',
  },
  {
    value: 'longgangmei',
    name: '龙港妹',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E6%B8%AF%E5%A6%B9.mp3',
  },
  {
    value: 'longshange',
    name: '龙陕哥',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E9%99%95%E5%93%A5.mp3',
  },
  {
    value: 'longanmin',
    name: '龙安敏',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E5%AE%89%E6%95%8F.mp3',
  },
  {
    value: 'longdaiyu',
    name: '龙黛玉',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E9%BB%9B%E7%8E%89.mp3',
  },
  {
    value: 'longgaoseng',
    name: '龙高僧',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E9%AB%98%E5%83%A7.mp3',
  },
  {
    value: 'longyichen',
    name: '龙逸尘',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E9%80%B8%E5%B0%98.mp3',
  },
  {
    value: 'longwanjun',
    name: '龙婉君',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E5%A9%89%E5%90%9B.mp3',
  },
  {
    value: 'longlaobo',
    name: '龙老伯',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E8%80%81%E4%BC%AF.mp3',
  },
  {
    value: 'longlaoyi',
    name: '龙老姨',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E8%80%81%E5%A7%A8.mp3',
  },
  {
    value: 'longbaizhi',
    name: '龙白芷',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E7%99%BD%E8%8A%B7.mp3',
  },
  {
    value: 'longsanshu',
    name: '龙三叔',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E4%B8%89%E5%8F%94.mp3',
  },
  {
    value: 'longxiu_v2',
    name: '龙修',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E4%BF%AE.mp3',
  },
  {
    value: 'longmiao_v2',
    name: '龙妙',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E5%A6%99.mp3',
  },
  {
    value: 'longyue_v2',
    name: '龙悦',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E6%82%A6.mp3',
  },
  {
    value: 'longnan_v2',
    name: '龙楠',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E6%A5%A0.mp3',
  },
  {
    value: 'longyuan_v2',
    name: '龙媛',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/voice/cosy-voice-v2/public/%E9%BE%99%E5%AA%9B.mp3',
  },
];
